import { useQuery } from '@tanstack/react-query';
import { db } from '@util/firebase';
import { useAuth } from 'context/AuthContext';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { ProductDocument } from 'models/product';

const colRef = collection(db, 'products');
export const useProducts = (ids: string[]) => {
  const data = useQuery<ProductDocument[]>({
    queryKey: ['products', ...ids],
    queryFn: async () => {
      const q = query(colRef, where('id', 'in', ids));
      const snapshot = await getDocs(q);
      return snapshot.docs.map((doc) => doc.data()) as ProductDocument[];
    },
    enabled: ids.length > 0,
  });

  return { data };
};
